import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GenericFieldSpecClass;
function GenericFieldSpec() {
  if (GenericFieldSpecClass === VOID) {
    class $ extends AbstractFieldSpec() {
      constructor(accessor, name, defaultValue, sign) {
        name = name === VOID ? accessor.i20() : name;
        defaultValue = defaultValue === VOID ? null : defaultValue;
        sign = sign === VOID ? null : sign;
        super();
        this.u20_1 = accessor;
        this.v20_1 = name;
        this.w20_1 = defaultValue;
        this.x20_1 = sign;
      }
      h20() {
        return this.u20_1;
      }
      i20() {
        return this.v20_1;
      }
      y20() {
        return this.w20_1;
      }
      z20() {
        return this.x20_1;
      }
    }
    initMetadataForClass($, 'GenericFieldSpec');
    GenericFieldSpecClass = $;
  }
  return GenericFieldSpecClass;
}
var PropertyAccessorClass;
function PropertyAccessor() {
  if (PropertyAccessorClass === VOID) {
    class $ {
      constructor(property) {
        this.a21_1 = property;
      }
      i20() {
        return this.a21_1.callableName;
      }
      b21(container, newValue) {
        var oldValue = this.a21_1.get(container);
        var tmp;
        if (oldValue === null) {
          this.a21_1.set(container, newValue);
          tmp = null;
        } else if (equals(oldValue, newValue)) {
          tmp = null;
        } else {
          tmp = oldValue;
        }
        return tmp;
      }
      s20(container, newValue) {
        var tmp = (container == null ? true : !(container == null)) ? container : THROW_CCE();
        return this.b21(tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
      }
      c21(container) {
        return this.a21_1.get(container);
      }
    }
    protoOf($).g20 = getterNotNull;
    initMetadataForClass($, 'PropertyAccessor', VOID, VOID, [Accessor()]);
    PropertyAccessorClass = $;
  }
  return PropertyAccessorClass;
}
var UnsignedFieldSpecClass;
function UnsignedFieldSpec() {
  if (UnsignedFieldSpecClass === VOID) {
    class $ extends AbstractFieldSpec() {
      constructor(accessor, minValue, maxValue, name, defaultValue, sign) {
        name = name === VOID ? accessor.i20() : name;
        defaultValue = defaultValue === VOID ? null : defaultValue;
        sign = sign === VOID ? null : sign;
        super();
        this.j20_1 = accessor;
        this.k20_1 = minValue;
        this.l20_1 = maxValue;
        this.m20_1 = name;
        this.n20_1 = defaultValue;
        this.o20_1 = sign;
        var tmp = this;
        var tmp_0;
        if (this.l20_1 < 10) {
          tmp_0 = 1;
        } else if (this.l20_1 < 100) {
          tmp_0 = 2;
        } else if (this.l20_1 < 1000) {
          tmp_0 = 3;
        } else {
          throw IllegalArgumentException().a1('Max value ' + this.l20_1 + ' is too large');
        }
        tmp.p20_1 = tmp_0;
      }
      h20() {
        return this.j20_1;
      }
      i20() {
        return this.m20_1;
      }
      y20() {
        return this.n20_1;
      }
      z20() {
        return this.o20_1;
      }
    }
    initMetadataForClass($, 'UnsignedFieldSpec');
    UnsignedFieldSpecClass = $;
  }
  return UnsignedFieldSpecClass;
}
function getterNotNull(container) {
  var tmp0_elvis_lhs = this.c21(container);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException().o4('Field ' + this.i20() + ' is not set');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var AccessorClass;
function Accessor() {
  if (AccessorClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Accessor');
    AccessorClass = $;
  }
  return AccessorClass;
}
var AbstractFieldSpecClass;
function AbstractFieldSpec() {
  if (AbstractFieldSpecClass === VOID) {
    class $ {
      toString() {
        return 'The field ' + this.i20() + ' (default value is ' + toString(this.y20()) + ')';
      }
    }
    initMetadataForClass($, 'AbstractFieldSpec');
    AbstractFieldSpecClass = $;
  }
  return AbstractFieldSpecClass;
}
//region block: exports
export {
  GenericFieldSpec as GenericFieldSpecnllvuuqbuxsd,
  PropertyAccessor as PropertyAccessor1m9zk65ebkfc4,
  UnsignedFieldSpec as UnsignedFieldSpec1pqzij1hidkca,
};
//endregion

//# sourceMappingURL=FieldSpec.mjs.map
